/**
  * Podio narrow layout singleton helper
  * Controls wether the general layout should be in wide or narrow mode
  * Registering a view in this helper triggers the narrow layout
  * The narrow layout is removed when there are no registered views needing it
  */

define('lib/RightPaneMediator',['require','underscore','jquery','lib/Podio.Event','lib/Podio.Utils'],function (require) {
  var narrowClass = 'layout-podio-narrow';
  var el = document.body;
  // This variable needs to be kept in sync with $right-pane-transition-duration from sass
  var paneAnimationTimeout = 200;

  var _ = require('underscore');
  var $ = require('jquery');
  var PodioEvent = require('lib/Podio.Event');
  var podioUtils = require('lib/Podio.Utils');

  var rightPane;
  var nextPane;

  function updateLayout() {
    var dfd = new $.Deferred();
    var wasClassApplied = $(el).hasClass(narrowClass);
    var shouldClassBeApplied = _.isDefined(rightPane) || _.isDefined(nextPane);

    if (wasClassApplied !== shouldClassBeApplied) {
      // use classList.toggle(className, boolean) when IE10 is no longer supported
      $(el).toggleClass(narrowClass, shouldClassBeApplied).trigger('classChange', [shouldClassBeApplied]);

      // Trigger window resize events for UI to adapt itself
      podioUtils.timedInterval(function () {
        PodioEvent.trigger('resize');
      }, 1, paneAnimationTimeout + 50);
    }

    setTimeout(dfd.resolve.bind(dfd), paneAnimationTimeout);

    return dfd;
  }

  function register(options) {
    if (!_.isFunction(options.open)) {
      throw new Error('RightPaneMediator.register: options.open must be a function');
    }
    if (!_.isFunction(options.close)) {
      throw new Error('RightPaneMediator.register: options.close must be a function');
    }
    if (_.isUndefined(options.id)) {
      throw new Error('RightPaneMediator.register: options.id must be defined and describe the identity of the caller');
    }

    var dfd = new $.Deferred();

    if (_.isDefined(nextPane)) {
      return dfd.reject('IN_PROGRESS');
    }

    if (rightPane && rightPane.id === options.id) {
      return dfd.reject('ALREADY_REGISTERED');
    }

    nextPane = options;

    dfd.resolve();

    if (_.isDefined(rightPane)) {
      dfd = unregister(rightPane);
    }

    dfd = dfd.then(function () {
      rightPane = nextPane;
      rightPane.open();
      return updateLayout();
    });

    dfd.done(function () {
      nextPane = void 0;
    });

    return dfd;
  }

  function unregister(options) {
    if (_.isUndefined(options.id)) {
      throw new Error('RightPaneMediator.unregister: options.id must be defined and describe the identity of the caller');
    }

    var dfd = new $.Deferred().resolve();

    if (rightPane && rightPane.id === options.id) {
      dfd = dfd.then(function () {
        rightPane.close();
        rightPane = void 0;
        return updateLayout();
      });
    } else {
      dfd.reject();
    }

    return dfd;
  }

  function close() {
    if (rightPane) {
      rightPane.close();
      rightPane = void 0;
      return updateLayout();
    } else {
      return new $.Deferred().reject();
    }
  }

  return {
    register: register,
    unregister: unregister,
    close: close
  };
});

